import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Link } from '@hub/link';
import { Imposter } from '@hub/imposter';
import { Text } from '@hub/text';
import { ShoppingCartMediumIcon } from '@hub/icon';
import { useToken } from '@hub/design-system-base';
import analyticsUtils from '../../../helpers/analytics-utils';
import trackClickEvent from '../../../helpers/analytics-utils/track-event';
import { useUniversalHeaderCart } from '../../../hooks/use-cart';
import { jsx as _jsx } from "react/jsx-runtime";
const MAX_CART_COUNT = 9;
export const Cart = _ref => {
  let {
    sx
  } = _ref;
  const hitTargetGrowthX = useToken('space', 'spacing-sm');
  const {
    count,
    url
  } = useUniversalHeaderCart();
  return /*#__PURE__*/_jsx(Link, {
    href: url,
    sx: _objectSpread({
      position: 'relative',
      display: 'flex',
      alignSelf: 'stretch',
      alignItems: 'center',
      top: [null, null, '-4px'],
      // Increase the hit target of the button
      '&:before': {
        content: '""',
        position: 'absolute',
        left: "-".concat(hitTargetGrowthX),
        right: "-".concat(hitTargetGrowthX),
        top: 0,
        bottom: 0
      }
    }, sx),
    "aria-label": "View your cart. ".concat(count === 0 ? 'No' : count, " item").concat(count === 1 ? '' : 's', "."),
    onClick: () => trackClickEvent(analyticsUtils.categories.UNIVERSAL_HEADER, analyticsUtils.actions.UNIVERSAL_HEADER_NAV_LINK_CLICK, analyticsUtils.labels.VIEW_CART),
    "data-id": "cart_cart-original_Cart_Link",
    children: /*#__PURE__*/_jsx(Imposter, {
      constrained: false,
      impose:
      /*#__PURE__*/
      // Why aren't we using a <Label> here? Unfortuantely the requirements
      // here deviate far enough from <Label> that it ends up undoing and
      // overriding more styles than introduced by doing it manually below.
      _jsx(Text, {
        tone: "strong",
        sx: {
          display: count === 0 ? 'none' : 'block',
          padding: '3px',
          borderRadius: '4px',
          // Ensure the padding _and_ the border take up space within the
          // box
          boxSizing: 'content-box',
          // Give the box a square-ish shape for thin numbers (eg: "1")
          minWidth: '1ch',
          // When text is thinner than '1ch', center it
          textAlign: 'center',
          border: '1px solid white',
          background: 'vibrantTeal',
          color: 'blueCharcoal',
          // When we have "9+", make sure it doesn't wrap
          whiteSpace: 'nowrap',
          // These magic numbers come from running the desired font size
          // through Capsize: https://seek-oss.github.io/capsize/
          fontSize: '12px',
          lineHeight: '8px',
          '::before': {
            content: "''",
            marginBottom: '0.022em',
            display: 'table'
          }
        },
        "data-id": "cart_cart-original_Cart_Text",
        children: count <= MAX_CART_COUNT ? count : "".concat(MAX_CART_COUNT, "+")
      }),
      position: "top-left",
      marginLeft: "50%",
      marginTop: "-2px",
      "data-id": "cart_cart-original_Cart_Link_Imposter",
      children: /*#__PURE__*/_jsx(ShoppingCartMediumIcon, {
        boxSize: "size-icon-md",
        "data-id": "cart_cart-original_Cart_Imposter_ShoppingCartMediumIcon"
      })
    })
  });
};